const AddToWishlistIcon = () => {
    return (
        <svg
            width="22"
            height="20"
            viewBox="0 0 22 20"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <path
                d="M19.9835 9.53329L11.0001 18.5166L2.0168 9.53329C0.0334636 7.54996 0.0334636 4.16663 2.0168 2.18329C3.0668 1.13329 4.35013 0.666626 5.75013 0.666626C7.03346 0.666626 8.43346 1.13329 9.48346 2.18329L11.0001 3.81663L12.6335 2.18329C14.6168 0.199959 18.0001 0.199959 19.9835 2.18329C21.9668 4.28329 21.9668 7.54996 19.9835 9.53329Z"
                stroke="black"
                strokeLinecap="round"
                strokeLinejoin="round"
            />
        </svg>
    )
}

export default AddToWishlistIcon
